import { DropDown } from "@assets";
import { Row } from "@components/Flex";
import { Caption } from "@components/Typography";
import { useState } from "react";
import { useStyles } from "./styles";
import { SelectionInputProps } from "./types";

export const SelectionInput = ({
  items = [],
  placeholder,
  label,
  defaultIndex,
  setSelectedIndex,
  onChangeSelection,
  style,
  readOnly = false,
}: SelectionInputProps) => {
  const styles = useStyles();

  const [selected, setSelected] = useState(defaultIndex != null);

  const disabledStyle = !selected ? styles.disabled : undefined;

  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        <div style={styles.innerContainer}>
          <Caption style={styles.label}>{label}</Caption>
          <Row style={styles.inputContainer}>
            <select
              style={{ ...styles.select, ...disabledStyle, ...style }}
              onChange={(event) => {
                setSelectedIndex?.(event.target.selectedIndex - 1);
                onChangeSelection?.(event.target.value);
                setSelected(true);
              }}
              disabled={readOnly}
            >
              <option value="" disabled selected>
                {placeholder}
              </option>
              {items.map((item, index) => (
                <option key={item} value={item} selected={defaultIndex === index}>
                  {item}
                </option>
              ))}
            </select>

            <span style={styles.right}>
              <DropDown />
            </span>
          </Row>
        </div>
      </div>
    </div>
  );
};
